/**
 * Partner specific configuration of the POA view
 */
export default {
	"nordfk-cob": {
		showFullmakt: true,
		showInsynsfullmakt: true,
		showForvaltarfullmakt: true,

		showAttachFullmaktWarning: true,
		forceAtLeastOneForvaltarfullmakt: false,
		showLongLabelForvaltarfullmakt: false
	},
	"auagfonder": {
		showFullmakt: false,
		showInsynsfullmakt: false,
		showForvaltarfullmakt: true,

		showAttachFullmaktWarning: true,
		forceAtLeastOneForvaltarfullmakt: false,
		showLongLabelForvaltarfullmakt: false
	},
	"alfakraft": {
		showFullmakt: false,
		showInsynsfullmakt: false,
		showForvaltarfullmakt: true,

		showAttachFullmaktWarning: true,
		forceAtLeastOneForvaltarfullmakt: true,
		showLongLabelForvaltarfullmakt: true
	}
};


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Poa/PoaConfig.js